const ROOMS = {
  ball: { title: 'Ballroom A&B', displayShort: 'Ball' },
  ballA: { title: 'Ballroom A', displayShort: 'Ball A' },
  ballB: { title: 'Ballroom B', displayShort: 'Ball B' },
  ballJr: { title: 'Junior Ballroom B&C', displayShort: 'Jr Ball' },
  posters: { title: 'Poster Hall', displayShort: 'Posters' },
  318: { title: '318', displayShort: '318' },
  308: { title: '308', displayShort: '308' },
  309: { title: '309-310', displayShort: '309-310' },
  319: { title: '319-320', displayShort: '319-320' },
  boardroom: { title: `Boardroom 2`, displayShort: 'Board2' },
  307: { title: '307', displayShort: '307' },
  304: { title: '304-306', displayShort: '304-306' },
  305: { title: '305-306', displayShort: '305-306' },
  concourse: {
    title: 'Grand Concourse and 312-316',
    displayShort: 'GC, 312-316',
  },
  away: { title: 'Principle Park', displayShort: 'Away' },
  hotel: { title: 'Hilton', displayShort: 'hilton' },
  many: { title: 'Many Rooms', displayShort: 'Many Rooms' },
  multi: { title: 'Multipurpose Room', displayShort: 'Multi Room' },
}

export { ROOMS }
